"use client";
import React from "react";
import { Collapse } from "antd";
import { useTranslations } from "next-intl";

type faqData = {
	key: string|number;
	question: string;
	answer: string;
};

const FAQ = ({ faqData }: { faqData: faqData[] }) => {
	const t=useTranslations()
	// 使用 items 属性定义折叠项
	const items = faqData.map((item,index) => ({
		key: item.key||index,
		label: t(item.question), // 替换原来的 header
		children: <p>{t(item.answer)}</p>, // 替换 Panel 中的内容
	}));

	return (
		<div className="py-12">
			<div className="rounded-lg bg-white p-4 shadow-lg">
				<Collapse
					size="middle"
					accordion
					expandIconPosition="end"
					className="site-collapse-custom-collapse"
					bordered={false}
					defaultActiveKey={["0"||0]}
					items={items} // 直接使用 items
				/>
			</div>
		</div>
	);
};

export default FAQ;
